export const checkIsPromise = (promise: any) =>
  !!promise && promise instanceof Promise && typeof promise.then === "function";
